export default __webpack_public_path__ + "static/media/021-rainy.23563fe4.svg";